import {Suspense} from 'react';
import {BaseUser} from '@legit-health/ui';
import {Box, Grid, Skeleton} from '@mui/material';
import {TFunction} from 'i18next';
import QrImage from './components/QrImage';
import SelectTemporaryImage from './components/SelectTemporaryImages/SelectTemporaryImages';

export default function TemporaryImages({
  maxImages,
  onChange,
  patient,
  t
}: {
  maxImages: number;
  onChange: (images: Blob[]) => void;
  patient: BaseUser;
  t: TFunction;
}) {
  return (
    <Box
      sx={{
        py: 4,
        px: 2,
        borderWidth: 1,
        borderStyle: 'solid',
        borderColor: 'secondary.main'
      }}
    >
      <Grid container spacing={4}>
        <Grid
          size={{
            xs: 12,
            lg: 2
          }}
        >
          <Suspense fallback={<Skeleton variant="rounded" width="100%" height={60} />}>
            <QrImage patient={patient} />
          </Suspense>
        </Grid>
        <Grid
          size={{
            xs: 12,
            lg: 10
          }}
        >
          <SelectTemporaryImage t={t} patient={patient} onFinish={onChange} maxImages={maxImages} />
        </Grid>
      </Grid>
    </Box>
  );
}
